import styled from 'styled-components';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export const TagPanelWrapper = styled.div`
    padding-bottom: 6px;
`;

export const ErrorWrapper = styled.div`
    padding: 2px 8px 6px 8px;
    width: 164px;
    height: 84px;
    background: #FEF4F5;
    border-radius: 4px;
    margin-bottom: 6px;
`;

export const ErrorIcon = styled(FontAwesomeIcon)<FontAwesomeIconProps>`
    font-size: 10px;
    padding: 8px 4px 0 0;
    color: #E82E41;
    cursor: pointer;
`;

export const ErrorText = styled.span`
    color: ${({ theme }) => theme.colors.danger700};
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
`;

export const Label = styled.h3`
    align-items: center;
    color: ${({ theme }) => theme.colors.neutral700};
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    width: 180px;
    padding-bottom: 10px;
`;

export const LoadingImg = styled.img`
    display: block;
    margin: 8px auto;
`;
